export * from './PhuketMapWithBeaches';
